module.exports = __webpack_public_path__ + "static/icon_buyStep4-70cb1d7dc853de0c19e28ce3d2fc4c15.png";